import { render, staticRenderFns } from "./ProjectCredits.vue?vue&type=template&id=6de64e36&scoped=true&"
import script from "./ProjectCredits.vue?vue&type=script&lang=js&"
export * from "./ProjectCredits.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCredits.vue?vue&type=style&index=0&id=6de64e36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de64e36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
